import { AppState, Auth0Provider } from "@auth0/auth0-react";

import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  domain: string;
  clientId: string;
  audience: string;
  children: ReactNode;
}

export default function Auth0ProviderWithRedirectCallback({
  domain,
  clientId,
  audience,
  children,
}: Props) {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    const returnTo = appState?.returnTo;
    const targetPath = returnTo
      ? returnTo.startsWith("/")
        ? returnTo
        : `/${returnTo}`
      : window.location.pathname;

    navigate(targetPath, { replace: true });
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: audience,
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
    >
      {children}
    </Auth0Provider>
  );
}
